/*
 * Copyright Thoughtworks, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import m from "mithril";
import {RewardBanner} from "views/components/reward_banner";
import {SearchBox} from "views/components/search_box";
import {f} from "helpers/form_helper";
import _ from "lodash";
import {ComponentMixins} from "helpers/mithril_component_mixins";
import {DashboardGroupsWidget} from "views/dashboard/dashboard_groups_widget";
import {PersonalizedViewsWidget} from "views/dashboard/personalized_views_widget";
import {Dropdown} from "views/shared/dropdown";

const GroupingSwitch = {
  view(vnode) {
    const vm = vnode.attrs.vm;

    return <Dropdown model={vm}
                     label="Group pipelines by:"
                     attrName="scheme"
                     class="grouping_select"
                     items={vm.groupByItems}/>;
  }
};

export const DashboardWidget = {
  oninit(vnode) {
    ComponentMixins.HasViewModel.call(vnode.state);
  },

  view(vnode) {
    const args          = vnode.attrs;
    const vm            = args.vm;
    const dashboard     = vm.dashboard;
    const personalizeVM = args.personalizeVM;

    const sharedGroupArgs = _.assign(_.pick(args, [
      "doCancelPolling",
      "doRefreshImmediately",
      "pluginsSupportingAnalytics", "shouldShowAnalyticsIcon"
    ]), _.pick(vm, ["operationMessages", "stageOverview", "dropdown", "buildCause"]));

    if (args.showSpinner()) {
      return (<span class="page-spinner"/>);
    }

    let messageView;
    if (!_.isEmpty(dashboard.message())) {
      const content = (<h3 class="dashboard-message text-center">{dashboard.message().content}</h3>);
      messageView   = (dashboard.message().type === 'info')
        ? (<f.info>{content} </f.info>)
        : (<f.alert>{content} </f.alert>);
    }

    return (
      <div class="pipeline_wrapper">
        <PersonalizedViewsWidget vm={personalizeVM}/>

        <div class="dashboard-container">
          {[<RewardBanner
            rewardText="Congratulations! You just created your first pipeline in GoCD!"
            key="addPipeline"
            query={m.parseQueryString(window.location.search).new_pipeline_name}
          />]}

          <section class="dashboard-modifiers">
            <GroupingSwitch vm={vm}/>
            <SearchBox width="350"
                       class="pipeline-search_dashboard"
                       model={vm} attrName="searchText"
                       placeholder="Search pipelines"/>
          </section>

          {messageView}
          <DashboardGroupsWidget scheme={vm.scheme()}
                                 testDrive={args.testDrive}
                                 invalidateEtag={vm.invalidateEtag}
                                 resolver={dashboard} {...sharedGroupArgs}
                                 groups={vm.filteredGroups(personalizeVM.currentFilter())}/>
        </div>
      </div>
    );
  }
};
